import * as React from "react";
import styled from "../../lib/styled";

interface ProfileProps {
  image?: string;
  title?: string;
  subHeading?: string;
  textArea?: string;
  occupation?: string;
  status?: string;
  layout: "left" | "right" | "top" | "bottom";
}

const ProfileBlock: React.FC<ProfileProps> = (props) => {
  return (
    <Wrapper className={`profile--wrapper align-${props.layout}`}>
      <div className="profile--image">
        <img src={props.image} alt={props.textArea} />
      </div>
      <div className="profile--text-area">
        <h3>{props.title}</h3>
        <h4>{props.subHeading}</h4>
        <p>{props.textArea}</p>

        {props.occupation && (
          <p>
            <span className="profile--label">Occupation:&nbsp;</span>
            {props.occupation}
          </p>
        )}
        {props.status && (
          <p>
            <span className="profile--label">Status:&nbsp;</span>
            {props.status}
          </p>
        )}
      </div>
    </Wrapper>
  );
};

export default ProfileBlock;

const Wrapper = styled.div`
  display: flex;
  margin: 10px 0;
  flex-direction: row;

  &.align-left {
    flex-direction: row;
    .profile--text-area {
      margin-left: 12px;
      flex: 2;
    }
  }

  &.align-right {
    flex-direction: row-reverse;
    .profile--text-area {
      margin-right: 12px;
      flex: 2;
    }
  }

  &.align-top {
    flex-direction: column;
    .profile--text-area {
      margin-top: 12px;
    }
  }

  &.align-bottom {
    flex-direction: column-reverse;
    .profile--text-area {
      margin-bottom: 12px;
    }
  }

  .profile--image {
    width: auto;
  }

  .profile--text-area {
    line-height: 1em;
    margin: 0;
    flex: 1;
    p {
      line-height: 1.2;

      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      margin: 0;
      padding-bottom: 10px;
    }

    h3 {
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      margin: 0;
      padding-bottom: 10px;
    }

    h4 {
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      margin: 0;
      padding-bottom: 10px;
      font-weight: 400;
      font-style: italic;
    }
  }

  .profile--label {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    margin: 0;
    padding-bottom: 10px;
    font-weight: bold;
  }
`;
